import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
} from '@locus-taxy/disco-ui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { TestIdAction } from '../../utils/testIdUtils';

interface UnsavedChangesDialogProps {
  readonly open: boolean;
  readonly onStay: () => void;
  readonly onLeave: () => void;
}

export function UnsavedChangesDialog({
  open,
  onStay,
  onLeave,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation();

  const handleOpenChange = (next: boolean) => {
    if (!next) {
      onStay();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        maxWidth="sm"
        data-testid={getTestId({
          action: TestIdAction.VIEW,
          object: 'unsaved-changes-dialog',
          page: 'account',
        })}
      >
        <DialogHeader>
          <DialogTitle>
            {t('dashboard.userDetails.unsavedChangesTitle', 'Unsaved Changes')}
          </DialogTitle>
        </DialogHeader>

        <Typography variant="body1" color="muted">
          {t(
            'dashboard.userDetails.unsavedChangesBody',
            'You have unsaved changes. If you leave this page, your changes will be lost.'
          )}
        </Typography>

        <DialogFooter>
          <Button
            variant="outline"
            size="lg"
            onClick={onStay}
            data-testid={getTestId({
              action: TestIdAction.VIEW,
              object: 'stay-on-page-button',
              page: 'account',
            })}
          >
            {t('dashboard.userDetails.stayOnPage', 'Stay on Page')}
          </Button>
          <Button
            variant="destructive"
            size="lg"
            onClick={onLeave}
            data-testid={getTestId({
              action: TestIdAction.VIEW,
              object: 'leave-page-button',
              page: 'account',
            })}
          >
            {t('dashboard.userDetails.leavePage', 'Leave Page')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
